(() => {
  if (window.tblDeferredImages) return;
  window.tblDeferredImages = true;
  const observed = new WeakSet();
  const load = element => {
    if (element.dataset.tblSrcset) {
      element.srcset = element.dataset.tblSrcset;
      delete element.dataset.tblSrcset;
    }
    if (element.dataset.tblSrc) {
      element.src = element.dataset.tblSrc;
      delete element.dataset.tblSrc;
    }
    if (element.hasAttribute('data-tbl-video')) {
      element.querySelectorAll('source[data-tbl-source]').forEach(source => {
        source.src = source.dataset.tblSource;
        delete source.dataset.tblSource;
      });
      element.removeAttribute('data-tbl-video');
      element.load();
      if (element.autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        element.play().catch(() => {});
      }
    }
    if (element.dataset.tblPoster) {
      element.poster = element.dataset.tblPoster;
      delete element.dataset.tblPoster;
    }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      load(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '200px' }) : null;
  const scan = () => document.querySelectorAll('[data-tbl-src], [data-tbl-poster], [data-tbl-video]').forEach(element => {
    if (observed.has(element)) return;
    observed.add(element);
    if (observer) observer.observe(element);
    else load(element);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
